import * as actions from "./actions";
import * as mutations from "./mutations";
import * as getters from "./getters";

// initial state
const state = {
  pagination: {
    currentPage: 1,
    lastPage: 2
  }
};

export default {
  state,
  getters,
  mutations,
  actions,
  modules: {}
};
